import { render, staticRenderFns } from "./RelatedProductSliderWrapper.vue?vue&type=template&id=bea65cc6"
import script from "./RelatedProductSliderWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedProductSliderWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports